import Vue from 'vue'
import Meta from 'vue-meta'
import { createRouter } from './router.js'
import NoSsr from './components/no-ssr.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_head_9f65fc0a from 'nuxt_plugin_head_9f65fc0a' // Source: ./purchase-quote/head.js (mode: 'all')
import nuxt_plugin_plugin0_33f89605 from 'nuxt_plugin_plugin0_33f89605' // Source: ./purchase-quote/plugin-0.js (mode: 'client')
import nuxt_plugin_plugin1_33f90a64 from 'nuxt_plugin_plugin1_33f90a64' // Source: ./purchase-quote/plugin-1.js (mode: 'all')
import nuxt_plugin_plugin2_33f97ec3 from 'nuxt_plugin_plugin2_33f97ec3' // Source: ./purchase-quote/plugin-2.js (mode: 'all')
import nuxt_plugin_plugin3_33f9f322 from 'nuxt_plugin_plugin3_33f9f322' // Source: ./purchase-quote/plugin-3.js (mode: 'all')
import nuxt_plugin_plugin4_33fa6781 from 'nuxt_plugin_plugin4_33fa6781' // Source: ./purchase-quote/plugin-4.js (mode: 'server')
import nuxt_plugin_plugin5_33fadbe0 from 'nuxt_plugin_plugin5_33fadbe0' // Source: ./purchase-quote/plugin-5.js (mode: 'client')
import nuxt_plugin_plugin6_33fb503f from 'nuxt_plugin_plugin6_33fb503f' // Source: ./purchase-quote/plugin-6.js (mode: 'all')
import nuxt_plugin_plugin7_33fbc49e from 'nuxt_plugin_plugin7_33fbc49e' // Source: ./purchase-quote/plugin-7.js (mode: 'all')
import nuxt_plugin_plugin8_33fc38fd from 'nuxt_plugin_plugin8_33fc38fd' // Source: ./purchase-quote/plugin-8.js (mode: 'all')
import nuxt_plugin_plugin9_33fcad5c from 'nuxt_plugin_plugin9_33fcad5c' // Source: ./purchase-quote/plugin-9.js (mode: 'all')
import nuxt_plugin_plugin10_4b2848fa from 'nuxt_plugin_plugin10_4b2848fa' // Source: ./purchase-quote/plugin-10.js (mode: 'all')
import nuxt_plugin_plugin11_4b28bd59 from 'nuxt_plugin_plugin11_4b28bd59' // Source: ./purchase-quote/plugin-11.js (mode: 'all')
import nuxt_plugin_plugin12_4b2931b8 from 'nuxt_plugin_plugin12_4b2931b8' // Source: ./purchase-quote/plugin-12.js (mode: 'all')
import nuxt_plugin_plugin13_4b29a617 from 'nuxt_plugin_plugin13_4b29a617' // Source: ./purchase-quote/plugin-13.js (mode: 'all')
import nuxt_plugin_plugin14_4b2a1a76 from 'nuxt_plugin_plugin14_4b2a1a76' // Source: ./purchase-quote/plugin-14.js (mode: 'all')
import nuxt_plugin_plugin15_4b2a8ed5 from 'nuxt_plugin_plugin15_4b2a8ed5' // Source: ./purchase-quote/plugin-15.js (mode: 'all')
import nuxt_plugin_plugin16_4b2b0334 from 'nuxt_plugin_plugin16_4b2b0334' // Source: ./purchase-quote/plugin-16.js (mode: 'all')
import nuxt_plugin_plugin17_4b2b7793 from 'nuxt_plugin_plugin17_4b2b7793' // Source: ./purchase-quote/plugin-17.js (mode: 'all')
import nuxt_plugin_plugin18_4b2bebf2 from 'nuxt_plugin_plugin18_4b2bebf2' // Source: ./purchase-quote/plugin-18.js (mode: 'all')
import nuxt_plugin_plugin19_4b2c6051 from 'nuxt_plugin_plugin19_4b2c6051' // Source: ./purchase-quote/plugin-19.js (mode: 'all')
import nuxt_plugin_plugin20_4b36607b from 'nuxt_plugin_plugin20_4b36607b' // Source: ./purchase-quote/plugin-20.js (mode: 'all')
import nuxt_plugin_plugin21_4b36d4da from 'nuxt_plugin_plugin21_4b36d4da' // Source: ./purchase-quote/plugin-21.js (mode: 'all')
import nuxt_plugin_plugin22_4b374939 from 'nuxt_plugin_plugin22_4b374939' // Source: ./purchase-quote/plugin-22.js (mode: 'all')
import nuxt_plugin_plugin23_4b37bd98 from 'nuxt_plugin_plugin23_4b37bd98' // Source: ./purchase-quote/plugin-23.js (mode: 'all')
import nuxt_plugin_plugin24_4b3831f7 from 'nuxt_plugin_plugin24_4b3831f7' // Source: ./purchase-quote/plugin-24.js (mode: 'all')

// Component: <NoSsr>
Vue.component(NoSsr.name, NoSsr)

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>`
Vue.component(Nuxt.name, Nuxt)

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    router,
    store,
    nuxt: {
      defaultTransition,
      transitions: [ defaultTransition ],
      setTransitions(transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [ transitions ]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },
      err: null,
      dateErr: null,
      error(err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        const nuxt = this.nuxt || this.$options.nuxt
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) ssrContext.nuxt.error = err
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    store,
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) throw new Error('inject(key, value) has no key provided')
    if (typeof value === 'undefined') throw new Error('inject(key, value) has no value provided')
    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) return
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Vue.prototype.hasOwnProperty(key)) {
        Object.defineProperty(Vue.prototype, key, {
          get() {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_head_9f65fc0a === 'function') {
    await nuxt_plugin_head_9f65fc0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin0_33f89605 === 'function') {
    await nuxt_plugin_plugin0_33f89605(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin1_33f90a64 === 'function') {
    await nuxt_plugin_plugin1_33f90a64(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin2_33f97ec3 === 'function') {
    await nuxt_plugin_plugin2_33f97ec3(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin3_33f9f322 === 'function') {
    await nuxt_plugin_plugin3_33f9f322(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_plugin4_33fa6781 === 'function') {
    await nuxt_plugin_plugin4_33fa6781(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin5_33fadbe0 === 'function') {
    await nuxt_plugin_plugin5_33fadbe0(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin6_33fb503f === 'function') {
    await nuxt_plugin_plugin6_33fb503f(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin7_33fbc49e === 'function') {
    await nuxt_plugin_plugin7_33fbc49e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin8_33fc38fd === 'function') {
    await nuxt_plugin_plugin8_33fc38fd(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin9_33fcad5c === 'function') {
    await nuxt_plugin_plugin9_33fcad5c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin10_4b2848fa === 'function') {
    await nuxt_plugin_plugin10_4b2848fa(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin11_4b28bd59 === 'function') {
    await nuxt_plugin_plugin11_4b28bd59(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin12_4b2931b8 === 'function') {
    await nuxt_plugin_plugin12_4b2931b8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin13_4b29a617 === 'function') {
    await nuxt_plugin_plugin13_4b29a617(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin14_4b2a1a76 === 'function') {
    await nuxt_plugin_plugin14_4b2a1a76(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin15_4b2a8ed5 === 'function') {
    await nuxt_plugin_plugin15_4b2a8ed5(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin16_4b2b0334 === 'function') {
    await nuxt_plugin_plugin16_4b2b0334(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin17_4b2b7793 === 'function') {
    await nuxt_plugin_plugin17_4b2b7793(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin18_4b2bebf2 === 'function') {
    await nuxt_plugin_plugin18_4b2bebf2(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin19_4b2c6051 === 'function') {
    await nuxt_plugin_plugin19_4b2c6051(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin20_4b36607b === 'function') {
    await nuxt_plugin_plugin20_4b36607b(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin21_4b36d4da === 'function') {
    await nuxt_plugin_plugin21_4b36d4da(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin22_4b374939 === 'function') {
    await nuxt_plugin_plugin22_4b374939(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin23_4b37bd98 === 'function') {
    await nuxt_plugin_plugin23_4b37bd98(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin24_4b3831f7 === 'function') {
    await nuxt_plugin_plugin24_4b3831f7(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    app,
    store,
    router
  }
}

export { createApp, NuxtError }
